import { IApplicationState } from '@store/index'

export const selectPostPurchaseBrandConnectMetrics = (
  state: IApplicationState,
  submissionId: number,
) => state.postPurchaseAnalytics.brandConnectAnalyticsBySubmissionId[submissionId] || []

export const selectIsFetchingPostPurchaseAnalytics = (state: IApplicationState) =>
  state.postPurchaseAnalytics.isFetching
